module.exports = __webpack_public_path__ + "static/media/pspo1.891ec8f6.png";